import React from 'react'

function OurFleet() {
  return (
    <>
     <div className='container-fluid mt-100'>
      <div className='row'>
        <div className='col-md-12 position-relative p-0'>
           <img src='./About.jpg' className='img-fluid'/>
        </div>
      </div>
     </div>
     <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <h1 className='heading'>Our <span>Fleet</span></h1>
          <p style={{minHeight:'200px', textAlign:'center'}}>Coming Soon...</p>
        </div>
      </div>
     </div>
    </>
  )
}

export default OurFleet
